<template>
    <b-container fluid style="margin-top: 60px">
        <h1>
            {{ title }} &nbsp;
            <!--b-button @click="flipTesten()">
                {{ btnTekst }}
            </b-button-->
            <b-button
                @click="forcedLoadData()"
                class="bgc_aux_normal"
                v-b-tooltip.hover
                :title="$t('com_refresh', { ns: 'common' })"
                ><font-awesome-icon icon="arrow-down" size="1x" />
            </b-button>
        </h1>

        <div slot="pdfdata">
            <b-row no-gutters>
                <b-col sm="12">
                    <b-col lg="6" class="my-1">
                        <b-form-group
                            :label="$t('com_filter', { ns: 'common' })"
                            label-for="filter-input"
                            label-cols-sm="3"
                            label-align-sm="right"
                            label-size="sm"
                            class="mb-0"
                        >
                            <b-input-group size="sm">
                                <b-form-input
                                    id="filter-input"
                                    v-model="filter"
                                    type="search"
                                    :placeholder="
                                        $t('com_typetosearch', { ns: 'common' })
                                    "
                                ></b-form-input>

                                <b-input-group-append>
                                    <b-button
                                        :disabled="!filter"
                                        @click="filter = ''"
                                        >{{
                                            $t('com_wis', { ns: 'common' })
                                        }}</b-button
                                    >
                                </b-input-group-append>
                            </b-input-group>
                            <b-button
                                v-if="
                                    allowEdit &&
                                    checkRight('AnalyticsConfigure')
                                "
                                size="sm"
                                @click="createNewItem()"
                                class="bgc_aux_normal"
                                ><font-awesome-icon
                                    icon="folder-plus"
                                    size="1x"
                                />
                            </b-button>
                        </b-form-group>
                    </b-col>

                    <b-col lg="6" class="my-1">
                        <b-form-group
                            :label="$t('com_perpagina', { ns: 'common' })"
                            label-for="per-page-select"
                            label-cols-sm="6"
                            label-cols-md="4"
                            label-cols-lg="3"
                            label-align-sm="right"
                            label-size="sm"
                            class="mb-0"
                        >
                            <b-form-select
                                id="per-page-select"
                                v-model="perPage"
                                :options="pageOptions"
                                size="sm"
                            ></b-form-select>
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="totalRows"
                                :per-page="perPage"
                                align="fill"
                                size="sm"
                                class="my-0"
                            ></b-pagination>
                        </b-form-group>
                    </b-col>
                    <b-table
                        :items="displayList"
                        :fields="visibleFields"
                        :current-page="currentPage"
                        :per-page="perPage"
                        :filter="filter"
                        :filter-included-fields="filterOn"
                        stacked="md"
                        show-empty
                        :empty-text="$t('com_geen_data', { ns: 'common' })"
                        small
                        striped
                        @filtered="onFiltered"
                    >
                        <template v-slot:cell(actions)="row">
                            <div class="form-inline">
                                <b-button
                                    v-if="checkRight('AnalyticsConfigure')"
                                    size="sm"
                                    @click="bewerkItem(row.item)"
                                    class="bgc_aux_warning"
                                    :disabled="checkSystemData(row.item)"
                                    ><font-awesome-icon icon="edit" size="1x" />
                                </b-button>
                                <b-button
                                    v-if="checkRight('AnalyticsConfigure')"
                                    size="sm"
                                    @click="verwijderItem(row.item)"
                                    :disabled="checkSystemData(row.item)"
                                    class="bgc_aux_alarm"
                                    ><font-awesome-icon
                                        icon="trash-alt"
                                        size="1x"
                                    />
                                </b-button>
                                <b-button
                                    size="sm"
                                    @click="infoItem(row.item)"
                                    class="bgc_aux_unknown"
                                    ><font-awesome-icon
                                        icon="info-circle"
                                        size="1x"
                                    />
                                </b-button>
                            </div>
                        </template>
                        <template v-slot:row-details>
                            <invest-quantity-card
                                v-bind:normList="detailList"
                                v-bind:detailID="detailID"
                            >
                            </invest-quantity-card>
                        </template>
                    </b-table>
                    <div v-if="displayList.length == 0">
                        {{ $t('com_geen_data', { ns: 'common' }) }}
                    </div>
                </b-col>
            </b-row>
        </div>
        <modal-invest-quantity
            v-if="showDetails"
            v-model="showDetails"
            v-bind:inItem="investigationQuantity"
            @hide="reset"
        />
    </b-container>
</template>

<script>
import ModalInvestQuantity from './ModalInvestQuantity.vue';
import InvestQuantityCard from './InvestQuantityCard.vue';
import DateHelper from '../../models/DateHelper';
import Helper from '@/models/Helper';
import { Permission } from '../../models/Permissions';
import { loadList, loadItem } from './utils';

export default {
    name: 'InvestQuantityBase',
    data: function () {
        return {
            showDetails: false,
            investigationQuantity: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 20,
            pageOptions: [10, 20, 40, { value: 100, text: '100' }],
            filter: null,
            filterOn: [],
            aangeraakt_teller: 1,
            testen: false,
            localItem: null,
            detailList: [],
            detailID: -1,
            forcerefresh: false
        };
    },
    components: {
        ModalInvestQuantity,
        InvestQuantityCard
    },
    computed: {
        title() {
            return Helper.stringformat(
                '{0}: {1}',
                this.$t('an_meetbaar', { ns: 'analytics' }),
                this.testen
                    ? this.$t('an_tests', { ns: 'analytics' }).toLowerCase()
                    : this.$t('an_metingen', { ns: 'analytics' }).toLowerCase()
            );
        },
        btnTekst() {
            return Helper.stringformat(
                '{0} {1}',
                this.$t('com_show', { ns: 'common' }),
                this.testen
                    ? this.$t('an_metingen', { ns: 'analytics' }).toLowerCase()
                    : this.$t('an_tests', { ns: 'analytics' }).toLowerCase()
            );
        },
        visibleFields() {
            const fieldsInit = [
                { key: 'actions', label: ' ', visible: true },
                { key: 'id', label: 'Id', sortable: false, visible: false },
                {
                    key: 'naam',
                    label: this.$t('an_meting', { ns: 'analytics' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'grootheid',
                    label: this.$t('an_grootheid', { ns: 'analytics' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'uitvoerder',
                    label: this.$t('an_standaardx', {
                        ns: 'analytics',
                        val: this.$t('an_uitvoerder', {
                            ns: 'analytics'
                        }).toLowerCase()
                    }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'bijlagen',
                    label: this.$t('com_bijlagen', { ns: 'common' }),
                    sortable: true,
                    visible: true,
                    formatter: (value, key, item) => {
                        return item.bijlagen > 0 ? item.bijlagen : '';
                    }
                },
                {
                    key: 'normen',
                    label: this.$t('com_normen', { ns: 'common' }),
                    sortable: true,
                    visible: true,
                    formatter: (value, key, item) => {
                        return item.normen > 0 ? item.normen : '';
                    }
                },
                {
                    key: 'herhaling',
                    label: this.$t('rec_pattern', { ns: 'recurrency' }),
                    sortable: true,
                    visible: true,
                    formatter: (value, key, item) => {
                        return item.herhaling > 0 ? item.herhaling : '';
                    }
                }
            ];
            const fieldsInitAssesment = [
                { key: 'actions', label: ' ', visible: true },
                { key: 'id', label: 'Id', sortable: false, visible: false },
                {
                    key: 'meettijdstip',
                    label: this.$t('an_meettijd', { ns: 'analytics' }),
                    sortable: true,
                    visible: true,
                    formatter: 'displayDate'
                },
                {
                    key: 'waarde',
                    label: this.$t('an_result', { ns: 'analytics' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'eenheidNaam',
                    label: this.$t('com_unit', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'meetplekNaam',
                    label: this.$t('an_meetplaats', { ns: 'analytics' }),
                    sortable: true,
                    visible: true
                }
            ];
            return this.testen
                ? fieldsInitAssesment.filter((field) => field.visible)
                : fieldsInit.filter((field) => field.visible);
        },
        displayList() {
            const lijst = this.testen
                ? []
                : this.$store.getters['analytics/getIQLijst'];
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.totalRows = lijst ? lijst.length : 0;
            return lijst;
        },
        allowEdit() {
            // todo: wat worden de regels hiervoor?
            return true;
        }
    },
    methods: {
        async infoItem(row) {
            if (row._showDetails) {
                this.$set(row, '_showDetails', false);
            } else {
                this.displayList.forEach((row) => {
                    this.$set(row, '_showDetails', false);
                });
                let lijst = [];
                this.testen
                    ? (this.measurement = await loadItem(
                          'analytics/loadAssesment',
                          { assesmentid: row.id }, // Todowas   { measurementID: row.id }
                          this.$t
                      ))
                    : (lijst = await loadList(
                          'analytics/getNormLijst',
                          'analytics/loadNormenLijst',
                          null,
                          this.forcerefresh,
                          this.$t
                      ));
                this.detailID = row.id;
                this.detailList = lijst.filter(
                    (x) => x.onderzoeksgrootheidID == row.id
                );
                this.$set(row, '_showDetails', true);
            }
        },
        flipTesten() {
            this.testen = !this.testen;
            this.loadData();
        },
        reset() {
            this.showDetails = false;
        },
        displayDate(value) {
            return DateHelper.convertedToDate(value, true);
        },
        showMaesurementInsert(value) {
            if (value == undefined) return;
            this.barcodeEO = value;
            this.showDetails = !this.showDetails;
        },
        async bewerkItem(row) {
            this.investigationQuantity = null;
            if (row) {
                this.testen
                    ? (this.investigationQuantity = await loadItem(
                          'analytics/loadAssesment',
                          { assesmentid: row.id },
                          this.$t
                      ))
                    : (this.investigationQuantity = await loadItem(
                          'analytics/loadInvestigationQuantity',
                          { investigationquantityID: row.id },
                          this.$t
                      ));
            }
            this.showDetails = !this.showDetails;
        },
        async createNewItem() {
            this.investigationQuantity = null;
            this.showDetails = !this.showDetails;
        },
        async verwijderItem(row) {
            const bericht =
                this.$t('com_delete', {
                    ns: 'common',
                    val: this.testen
                        ? this.$t('an_test', { ns: 'analytics' })
                        : this.$t('an_meetpunt', { ns: 'analytics' })
                }) + row.naam;
            const doClose = await this.$root.showConfirmationBox(bericht);
            if (doClose) {
                this.testen
                    ? await loadItem(
                          'analytics/deleteAssesment',
                          {
                              assesmentID: row.id
                          },
                          this.$t
                      )
                    : await loadItem(
                          'analytics/deleteInvestigationQuantity',
                          {
                              investigationQuantityID: row.id
                          },
                          this.$t
                      );
            }
            this.forcedLoadData();
        },
        forcedLoadData() {
            this.forcerefresh = true;
            this.loadData();
        },
        loadData() {
            this.testen
                ? []
                : loadList(
                      'analytics/getIQLijst',
                      'analytics/loadInvestQuantityLijst',
                      null,
                      this.forcerefresh,
                      this.$t
                  );
            this.aangeraakt_teller += 1;
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        checkSystemData(row) {
            if (row) {
                return row.id < 999 ? true : false; //systeem data
            }
            return true;
        },
        checkRight(recht) {
            const id = Permission.enum(recht);
            return this.$root.handleRight(id);
        }
    },
    mounted: function () {
        this.loadData();
        this.totalRows = this.displayList ? this.displayList.length : 0;
    },
    created() {}
};
</script>

<style scoped></style>

